import React from 'react';
import clsx from 'clsx';
import {convertExternalEcoSysLinks, dompurifyConfig} from '../../../utils/utils';
import dompurify from 'isomorphic-dompurify';
import * as blocLiensStyles from '../../../styles/admissions/admissions.module.scss';
import { PropTypes } from 'prop-types';

import parse from 'html-react-parser';

import {isEcoWebInlineImage,
  nodeToEcoWebInlineImage} from '../ckeditor/ck-utils';


const Thumbnail = ({ title, html, color }) => {
  const sanitizer = dompurify.sanitize;
  html = convertExternalEcoSysLinks(html);
  html = sanitizer(html, dompurifyConfig);

  const options = {
    replace (domNode) {
      if (isEcoWebInlineImage(domNode)) {
        return nodeToEcoWebInlineImage(domNode);
      }
    }
  };

  return (
    <>
      <div
        className={clsx(
          blocLiensStyles.rootTitleThumbnail, {
            [blocLiensStyles.darkBlocLiensEntete]: color === 'BLACK',
            [blocLiensStyles.redBlocLiensEntete]: color !== 'BLACK'})
        }
      >
        <div className={blocLiensStyles.titleItemThumbnail}>
          <h2 className={blocLiensStyles.titleThumbnail}>
            {title}
          </h2>
        </div>
      </div>
      <div
        className={clsx(
          blocLiensStyles.rootContentThumbnail, {
            [blocLiensStyles.darkBlocLiensCorps]: color === 'BLACK',
            [blocLiensStyles.redBlocLiensCorps]: color !== 'BLACK'})
        }
      >
        <div className={blocLiensStyles.contentThumbnail}>
          <div
            className="ckContent ck-thumbnails"
          >
            {parse(html, options)}
          </div>
        </div>
      </div>
    </>
  );
};

Thumbnail.propTypes = {
  color: PropTypes.string,
  html: PropTypes.string,
  title: PropTypes.string,
};

export default Thumbnail;
